module.exports = __webpack_public_path__ + "static/media/kneecapview.bf1228a9.jpg";